import React, { Component } from "react";
import { Table, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import ColumnAction from "./ColumnAction";
import ColumnAvatar from "./ColumnAvatar";
import ColumnImage from "./ColumnImage";
import ColumnLink from "./ColumnLink";
import TableListToolbar from "./TableListToolbar";

import "./index.less";

class TableList extends Component {

  state = {
    columns: null,
    scroll: {
      y: 0,
    },
  };

  __divRef = null;
  __refreshTimeId = null;
  __resizeObserver = null;

  componentWillUnmount() {
    if (this.__resizeObserver) {
      this.__resizeObserver.disconnect();
      this.__resizeObserver = null;
    }
  }

  onDivRef = (e) => {
    if (e && typeof this.props.scroll == "undefined") {
      this.__divRef = e;
      this.refreshHeight(333);
      this.__initResizeObserver();
    };
  }

  refreshHeight = (ms = 0) => {
    if (this.__refreshTimeId) {
      clearTimeout(this.__refreshTimeId);
      this.__refreshTimeId = null;
    }
    this.__refreshTimeId = setTimeout(() => {
      const parentEle = this.__divRef.parentElement;
      // 表格内容顶部高度
      const thead = parentEle.querySelector(".ant-table-thead");
      const theadBottom = thead.getBoundingClientRect().bottom;
      // 表格内容底部高度
      const table = this.__divRef;
      const tableBottom = table.getBoundingClientRect().bottom;
      // 分页组件
      let heigth = tableBottom - theadBottom;
      if (this.props.pagination) {
        // 分页组件高度 + 间距
        heigth -= 44 + 4;
      } else {
        heigth -= 10;
      }
      this.setState({
        ...this.state,
        scroll: {
          y: heigth,
        },
      });
    }, ms);
  };

  __initResizeObserver = () => {
    this.__resizeObserver = new ResizeObserver(() => {
      this.refreshHeight(1);
    });
    this.__resizeObserver.observe(this.__divRef);
  };

  onChange = (page, filters, sorter, extra) => {
    if (this.props.onChange) {
      this.props.onChange(page, filters, sorter, extra);
    }
    const { action } = extra;
    if ("paginate" === action) {
      const { pageNum, pageSize } = this.props.data;
      if (pageNum !== page.current) {
        const { pagination } = this.props;
        pagination && pagination.onPageNumChange && pagination.onPageNumChange(page.current);
      } else if (pageSize !== page.pageSize) {
        const { pagination } = this.props;
        pagination && pagination.onPageSizeChange && pagination.onPageSizeChange(page.pageSize);
      }
    }
  };

  /**
   * 自定义页码的结构
   * @param {*} _
   * @param {string} type
   * @param {*} originalElement
   * @returns
   */
  pageItemRender = (_, type, originalElement) => {
    if ("prev" === type) {
      return <Button type="link" size="small" icon={<LeftOutlined />} />;
    }
    if ("next" === type) {
      return <Button type="link" size="small" icon={<RightOutlined />} />;
    }
    return originalElement;
  };

  /**
   * 分页显示总条数
   * @param {number} total 数量
   * @param {array} range 条数范围
   * @returns
   */
  showTotal = (total, range) => {
    return `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`;
  };

  getPagination = () => {
    const { data, pagination, } = this.props;
    if (pagination) {
      const paginationWrap = {
        size: "small",
        total: data.total,
        showSizeChanger: true,
        showQuickJumper: true,
        current: data.pageNum,
        pageSize: data.pageSize,
        itemRender: this.pageItemRender,
        pageSizeOptions: [10, 20, 50, 100, 200, 500,],
        showTotal: this.showTotal,
        ...pagination,
      };
      return paginationWrap;
    }
    return false;
  };

  getColumns = () => {
    const { columns } = this.props;
    return typeof columns === "undefined" ? this.props.columns : columns;
  };

  onColumnChange = (values) => {
    const columns = this.props.columns.filter(v => {
      return false !== v.visible && values.includes(v.dataIndex);
    });
    this.setState({
      ...this.state,
      columns,
    });
  };

  render() {
    const { style, data, rowKey = "id", loading, rowSelection, toolbar, onRow, childrenColumnName, expandable } = this.props;
    const scroll = typeof this.props.scroll == "undefined" ? this.state.scroll : this.props.scroll;
    return (
      <div
        className="nano-table-list"
        ref={this.onDivRef}
        style={style}
      >
        <div className={false === toolbar ? "nano-table-list-toolbar-hide" : ""}>
          {toolbar && (
            <TableListToolbar
              loading={loading}
              columns={this.props.columns}
              onColumnChange={this.onColumnChange}
              {...toolbar}
            />
          )}
        </div>
        <Table
          className="nano-table"
          bordered
          onRow={onRow}
          rowKey={rowKey}
          scroll={scroll}
          loading={loading}
          dataSource={data.list}
          expandable={expandable}
          onChange={this.onChange}
          rowSelection={rowSelection}
          columns={this.state.columns}
          pagination={this.getPagination()}
          childrenColumnName={childrenColumnName}
        />
      </div>
    );
  };
};


TableList.ColumnAction = ColumnAction;

TableList.ColumnAvatar = ColumnAvatar;

TableList.ColumnImage = ColumnImage;

TableList.ColumnLink = ColumnLink;

export default TableList;
